const equipment = [
  { label: "Controller", value: "CONTROLLER" },
  { label: "All in one unit", value: "ALL_IN_ONE_UNIT" },
  { label: "CDJs/Players", value: "CDJS_PLAYERS" },
  { label: "Turntables", value: "TURNTABLES" },
];

export default equipment;
